import React from 'react';
import Icon from '../../common/Icons';
import { HEAD_DOCTOR_COPY } from '../headDoctorCopy';

const COPY = HEAD_DOCTOR_COPY.REPORTS;

export default function ReportsRestPeopleInsight({ summary, loading, className = '' }) {
  if (loading) return null;

  const persons = Number(summary?.rest_day_unique_persons || 0);
  if (persons <= 0) return null;

  const members = Number(summary?.rest_day_unique_members || 0);
  const certificates = Number(summary?.rest_day_certificates || 0);
  const days = Number(summary?.rest_day_total_days || 0);

  const details = [];
  if (members > 0 && members !== persons) {
    details.push(COPY.REST_PEOPLE_INSIGHT_MEMBERS.replace('{n}', members.toLocaleString('fr-FR')));
  } else if (members > 0) {
    details.push(COPY.REST_PEOPLE_INSIGHT_ALL_MEMBERS);
  }
  if (certificates > 0) {
    details.push(COPY.REST_PEOPLE_INSIGHT_CERTS.replace('{n}', certificates.toLocaleString('fr-FR')));
  }
  if (days > 0) {
    details.push(COPY.REST_PEOPLE_INSIGHT_DAYS.replace('{n}', days.toLocaleString('fr-FR')));
  }

  return (
    <p className={`hd-reports-people-insight ${className}`.trim()} role="status">
      <span className="hd-reports-people-insight__icon" aria-hidden>
        <Icon name="user" size={15} />
      </span>
      <span className="hd-reports-people-insight__text">
        <strong className="hd-reports-people-insight__value">{persons.toLocaleString('fr-FR')}</strong>
        {' '}
        {COPY.REST_PEOPLE_INSIGHT}
        {details.length > 0 ? (
          <span className="hd-reports-people-insight__meta"> · {details.join(' · ')}</span>
        ) : null}
      </span>
    </p>
  );
}
